import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Layout, { DateInput } from "./Layout";
import { getApiUrl, getTodayIso } from "./config";

function ProfitLossReport() {
  const today = getTodayIso();
  const [from, setFrom] = useState(today);
  const [to, setTo] = useState(today);
  const [data, setData] = useState({
    sales_total: 0,
    purchases_total: 0,
    expenses_total: 0,
    opening_stock_weight: 0,
    opening_stock_value: 0,
    closing_stock_weight: 0,
    closing_stock_value: 0,
    cogs: 0,
    profit: 0,
  });

  const fetchPL = useCallback(async () => {
    try {
      const res = await axios.get(`${getApiUrl()}/reports/profit-loss`, { params: { from, to } });
      setData(res.data);
    } catch (err) {
      console.error(err);
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.sqlMessage ||
        err?.response?.data?.code ||
        "Failed to load profit & loss";
      alert(message);
    }
  }, [from, to]);

  useEffect(() => {
    fetchPL();
  }, [fetchPL]);

  const handleExportPdf = () => {
    window.print();
  };

  return (
    <Layout>
      <div className="container mt-4">
        <h2>Profit &amp; Loss</h2>

        <div className="card p-4 mb-4 no-print">
          <div className="row g-3 align-items-end">
            <div className="col-md-3">
              <label className="form-label fw-bold">From</label>
              <DateInput value={from} onChange={setFrom} />
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">To</label>
              <DateInput value={to} onChange={setTo} />
            </div>
            <div className="col-md-3 d-grid">
              <button type="button" className="btn btn-primary" onClick={fetchPL}>
                Refresh
              </button>
            </div>
            <div className="col-md-3 d-grid">
              <button type="button" className="btn btn-outline-dark" onClick={handleExportPdf}>
                Export PDF
              </button>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-3 mb-3">
            <div className="card p-4 shadow-sm border-0">
              <div className="text-uppercase small fw-bold text-secondary">Sales</div>
              <div className="display-6 fw-bold">₹ {(data.sales_total || 0).toFixed(2)}</div>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="card p-4 shadow-sm border-0">
              <div className="text-uppercase small fw-bold text-secondary">Purchases</div>
              <div className="display-6 fw-bold">₹ {(data.purchases_total || 0).toFixed(2)}</div>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="card p-4 shadow-sm border-0">
              <div className="text-uppercase small fw-bold text-secondary">Expenses</div>
              <div className="display-6 fw-bold">₹ {(data.expenses_total || 0).toFixed(2)}</div>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="card p-4 shadow-sm border-0">
              <div className="text-uppercase small fw-bold text-secondary">Profit</div>
              <div className={`display-6 fw-bold ${(data.profit || 0) >= 0 ? "text-success" : "text-danger"}`}>
                ₹ {(data.profit || 0).toFixed(2)}
              </div>
            </div>
          </div>
        </div>

        <div className="card p-4 shadow-sm border-0">
          <h5 className="mb-3">Stock &amp; COGS</h5>
          <div className="table-responsive">
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <th>Opening Stock (Weight)</th>
                  <td>{parseFloat(data.opening_stock_weight || 0).toFixed(2)}</td>
                  <th>Opening Stock (Value)</th>
                  <td>₹ {(data.opening_stock_value || 0).toFixed(2)}</td>
                </tr>
                <tr>
                  <th>Closing Stock (Weight)</th>
                  <td>{parseFloat(data.closing_stock_weight || 0).toFixed(2)}</td>
                  <th>Closing Stock (Value)</th>
                  <td>₹ {(data.closing_stock_value || 0).toFixed(2)}</td>
                </tr>
                <tr>
                  <th>COGS</th>
                  <td colSpan="3">₹ {(data.cogs || 0).toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default ProfitLossReport;
